(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["board-butter-cart-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-board-butter-add]');

    if (!button) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(button.dataset.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(button.dataset.variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) throw new Error('Unable to add Board Butter');

      window.location.assign(button.dataset.cartUrl);
    } catch {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.location.assign(button.dataset.productUrl);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gng-display-stand-offer"] && !Shopify.designMode) return;
  try {
    if (!window.gngStandOfferBound) {
  window.gngStandOfferBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gng-stand-add]');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const status = button.closest('.gng-stand-offer').querySelector('[role="status"]');
    status.textContent = '';
    try {
      const response = await fetch(button.dataset.addUrl + '.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          items: [{id: Number(button.dataset.variantId), quantity: 1}],
          sections: ['cart-drawer', 'header-cart-status'],
          sections_url: window.location.pathname
        })
      });
      const result = await response.json();
      if (!response.ok) throw new Error('stand_add_failed');
      if (button.dataset.context !== 'product') {
        window.location.assign(button.dataset.cartUrl);
        return;
      }
      status.textContent = button.dataset.success;
      for (const [sectionId, html] of Object.entries(result.sections || {})) {
        if (!html) continue;
        const current = document.getElementById('shopify-section-' + sectionId);
        if (!current) continue;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.getElementById('shopify-section-' + sectionId);
        if (replacement) current.innerHTML = replacement.innerHTML;
      }
    } catch {
      status.textContent = button.dataset.error;
      button.disabled = false;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gng-handle-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gng-handle-preview')) {
 customElements.define('gng-handle-preview', class extends HTMLElement {
  connectedCallback() {
   this.section = this.closest('.shopify-section');
   this.onChoice = event => {
    const control = event.target;
    if (!control.matches('.js-variant-select-item, .js-variant-radio-item')) return;
    const items = Array.from(this.querySelectorAll('[data-handle-style]'));
    const match = items.find(item => item.dataset.handleStyle === control.value);
    if (match) items.forEach(item => { item.hidden = item !== match; });
   };
   this.section?.addEventListener('change', this.onChoice, true);
  }
  disconnectedCallback() { this.section?.removeEventListener('change', this.onChoice, true); }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gng-insert-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gng-insert-preview')) {
    customElements.define('gng-insert-preview', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.onChoice = (event) => {
          const control = event.target;
          if (!control.matches('.js-variant-select-item, .js-variant-radio-item, select[name="id"]')) return;
          const figures = Array.from(this.querySelectorAll('[data-insert-design]'));
          const match = figures.find(figure => figure.dataset.insertDesign === control.value || figure.dataset.insertVariant === control.value);
          if (match) figures.forEach(figure => { figure.hidden = figure !== match; });
        };
        this.section?.addEventListener('change', this.onChoice, true);
      }
      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onChoice, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gng-personalization-fields"] && !Shopify.designMode) return;
  try {
    const syncGngPersonalization = (root = document) => {
    root.querySelectorAll('[data-gng-personalization]').forEach((container) => {
      const section = container.closest('[data-ui-component="Main Product Section"]');
      const selected = section?.querySelector(
        'input[name="Personalization"]:checked, select[name="Personalization"], select[name="options[Personalization]"]'
      );
      const showFields = selected?.value.includes('Text') === true;

      container.hidden = !showFields;
      container.querySelectorAll('input').forEach((input) => {
        input.disabled = !showFields;
        if (input.dataset.gngRequired === 'true') {
          input.required = showFields;
        }
      });
    });
  };

  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'input[name="Personalization"], select[name="Personalization"], select[name="options[Personalization]"]'
      )
    ) {
      syncGngPersonalization(
        event.target.closest('[data-ui-component="Main Product Section"]') || document
      );
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    syncGngPersonalization(event.target);
  });

  syncGngPersonalization();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gng-wildlife-coaster-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gng-wildlife-picker')) {
  const remembered = new Map();
  customElements.define('gng-wildlife-picker', class extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('.gng-wildlife-options__select'));
      this.cards = Array.from(this.querySelectorAll('[data-design]'));
      if (this.inputs.length !== 4 || this.cards.length !== 8) return;
      this.copy = JSON.parse(this.querySelector('[data-picker-copy]').textContent);
      this.allowed = this.cards.map(card => card.dataset.design);
      const current = this.inputs.map(input => input.value).filter(value => this.allowed.includes(value));
      this.choices = (remembered.has(this.id) ? remembered.get(this.id) : current).filter(value => this.allowed.includes(value)).slice(0, 4);
      this.onClick = event => {
        const button = event.target.closest('button[data-picker-action]');
        if (!button || !this.contains(button) || button.disabled) return;
        const action = button.dataset.pickerAction;
        if (action === 'clear') {
          this.choices = [];
          remembered.set(this.id, []);
          this.inputs.forEach(input => { input.value = ''; input.setCustomValidity(''); });
          const quantity = this.inputs[0].form?.elements?.namedItem('quantity');
          if (quantity) quantity.value = '1';
          this.render();
          this.announce(this.copy.cleared);
          this.querySelector('[data-picker-action="add"]').focus();
        } else if (action === 'remove') {
          this.removeAt(Number(button.dataset.index));
          (this.querySelector('[data-picker-action="remove"]') || this.querySelector('[data-picker-action="add"]')).focus();
        } else {
          const value = button.closest('[data-design]').dataset.design;
          if (action === 'add') this.add(value);
          else this.removeAt(this.choices.lastIndexOf(value));
        }
      };
      this.addEventListener('click', this.onClick);
      this.dataset.ready = 'true';
      this.querySelector('[data-picker-ui]').hidden = false;
      this.querySelector('[data-picker-help]').hidden = false;
      const form = this.inputs[0].form;
      if (form) form.noValidate = true;
      this.onQuantity = event => { if (event.target.name === 'quantity') this.renderSetTotal(); };
      form?.addEventListener?.('input', this.onQuantity);
      form?.addEventListener?.('change', this.onQuantity);
      this.render(false);
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); const form = this.inputs?.[0]?.form; form?.removeEventListener?.('input', this.onQuantity); form?.removeEventListener?.('change', this.onQuantity); }
    add(value) {
      if (!this.allowed.includes(value)) return false;
      if (this.choices.length >= 4) { this.announce(this.copy.full); return false; }
      this.choices.push(value); this.render(); return true;
    }
    removeAt(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.choices.length) return false;
      this.choices.splice(index, 1); this.render(); return true;
    }
    announce(message) { this.querySelector('[data-picker-status]').textContent = message; }
    render(announce = true) {
      remembered.set(this.id, this.choices.slice());
      this.inputs.forEach((input, index) => {
        input.value = this.choices[index] || '';
        input.setCustomValidity('');
      });
      this.cards.forEach(card => {
        const count = this.choices.filter(value => value === card.dataset.design).length;
        card.querySelector('[data-design-count]').textContent = String(count);
        card.querySelectorAll('[data-picker-action="add"]').forEach(button => { button.disabled = this.choices.length === 4; });
        card.querySelector('[data-picker-action="subtract"]').disabled = count === 0;
        card.dataset.selected = count ? 'true' : 'false';
      });
      this.querySelector('[data-picker-count]').textContent = this.copy.count.replace('{count}', String(this.choices.length));
      const list = this.querySelector('[data-picker-selected]'); list.replaceChildren();
      this.choices.forEach((value, index) => {
        const card = this.cards.find(item => item.dataset.design === value);
        const item = document.createElement('li'), label = document.createElement('span'), button = document.createElement('button');
        label.textContent = `${index + 1}. ${card.dataset.label}`;
        button.type = 'button'; button.dataset.pickerAction = 'remove'; button.dataset.index = String(index);
        button.textContent = this.copy.remove;
        button.setAttribute('aria-label', this.copy.removeItem.replace('{number}', String(index + 1)).replace('{design}', card.dataset.label));
        item.append(label, button); list.append(item);
      });
      this.renderSetTotal();
      if (announce) this.announce(this.choices.length === 4 ? this.copy.complete : this.copy.count.replace('{count}', String(this.choices.length)));
    }
    renderSetTotal() {
      const quantity = Number(this.inputs[0].form?.elements?.namedItem('quantity')?.value || 1);
      const output = this.querySelector('[data-picker-total]');
      if (!output) return;
      if (!Number.isInteger(quantity) || quantity < 1) { output.textContent = this.copy.validQuantity; return; }
      const price = Number(this.dataset.unitPrice);
      if (!Number.isFinite(price)) return;
      const total = new Intl.NumberFormat(document.documentElement?.lang || 'en-CA', { style: 'currency', currency: this.dataset.currency || 'CAD', currencyDisplay: 'code' }).format(price * quantity / 100);
      output.textContent = this.copy.total.replace('{sets}', String(quantity)).replace('{coasters}', String(quantity * 4)).replace('{price}', total);
    }
    reportSelectionValidity() {
      const quantityInput = this.inputs[0].form?.elements?.namedItem('quantity');
      if (quantityInput && (!Number.isInteger(Number(quantityInput.value)) || Number(quantityInput.value) < 1)) { this.announce(this.copy.validQuantity); quantityInput.focus(); return false; }

      const valid = this.choices.length === 4 && this.choices.every(value => this.allowed.includes(value));
      if (!valid) {
        this.announce(this.copy.required);
        this.querySelector('[data-picker-count]').scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.querySelector('[data-picker-action="add"]:not(:disabled)')?.focus({ preventScroll: true });
      }
      return valid;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
